import { useCallback, useRef, useState } from "react";

export const useUsertourEventPropagationFix = () => {
  const listenerRefs = useRef(new Map());

  const [observer] = useState(() => {
    // Callback function to execute when mutations are observed
    const callback: MutationCallback = (mutationList) => {
      for (const mutation of mutationList) {
        // We only want to observe child added/deleted scenario.
        // When child added, it means that usertour tooltip is visible, otherwise it's hidden
        if (mutation.type === "childList") {
          const popperTooltip = document.querySelector(
            ".usertour-widget-popper"
          );

          // If usertour widget popper exists, it means usertour tooltip is visible
          if (popperTooltip) {
            /// 1. Override body style to remove "pointer-events: none" which is set by radix UI
            document.body.style = "pointer-events: auto";

            // Get all backdrop parts
            const backdropBlocks = document.querySelectorAll(
              ".usertour-widget-popper-block--visible"
            );

            // 2. We need to stop event propagation up to document, because radix's dismissible layer controls pointerdown events there.
            [...backdropBlocks].forEach((_block) => {
              const block = _block as HTMLElement;
              // Remove existing listener if any
              const existingHandler = listenerRefs.current.get(block);
              if (existingHandler) {
                block.removeEventListener("pointerdown", existingHandler);
              }

              // Add new listener
              const handler = (e: PointerEvent) => e.stopPropagation();
              block.addEventListener("pointerdown", handler);
              listenerRefs.current.set(block, handler);
            });
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    return new MutationObserver(callback);
  });

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const startObserver = useCallback(() => {
    let targetNode;

    intervalRef.current = setInterval(() => {
      targetNode = document.getElementById("usertour-widget");

      if (targetNode && intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;

        // Start observing the target node for configured mutations
        const config = { attributes: true, childList: true, subtree: true };
        observer.observe(targetNode, config);
      } else {
        console.log("Couldn't find usertour widget!!!");
      }
    }, 500);
  }, [observer]);

  const stopObserver = useCallback(() => {
    observer.disconnect();
  }, [observer]);

  return { startObserver, stopObserver };
};
